
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-40e3d636&scoped=true!postcss-loader!sass-loader?sourceMap!import-glob-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./event-card.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015&babelrc=false!import-glob-loader!component-example-dir-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./event-card.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-40e3d636!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./event-card.vue"),
  /* scopeId */
  "data-v-40e3d636",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/components/molecules/event-card/event-card.vue
// module id = 250
// module chunks = 4